export default "__VITE_ASSET__mZSGuTP0BEpcyfQ9d5s09A__"